var A;!function(A){A.WHATSAPP="WHATSAPP",A.VIBER="VIBER",A.TELEGRAM="TELEGRAM"}(A||(A={}));export{A as MarkdownVariant};
//# sourceMappingURL=MarkdownTextTypes.js.map
